import './tdcp-customer-price-list.scss';
import template from './tdcp-customer-price-list.html.twig';

const { Mixin } = Shopware;

Shopware.Component.register('tdcp-customer-price-list', {
    template,

    inject: ['repositoryFactory', 'acl'],

    mixins: [
        Mixin.getByName('listing'),
    ],

    data() {
        return {
            items: null,
            isLoading: false,
            sortBy: 'createdAt',
            sortDirection: 'DESC',
            total: 0,
            productNumberFilter: '',
            customerNumberFilter: '',
        };
    },

    metaInfo() {
        return {
            title: this.$createTitle(),
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('tdcp_price');
        },

        columns() {
            return [{
                property: 'product.productNumber',
                label: this.$tc('tdcp-customer-prices.list.column.productNumber'),
                allowResize: true,
                sortable: false,
            }, {
                property: 'product.name',
                label: this.$tc('tdcp-customer-prices.list.column.productName'),
                allowResize: true,
                sortable: false,
            }, {
                property: 'customer.customerNumber',
                label: this.$tc('tdcp-customer-prices.list.column.customerNumber'),
                allowResize: true,
                sortable: false,
            }, {
                property: 'customer.firstName',
                label: this.$tc('tdcp-customer-prices.list.column.customerName'),
                allowResize: true,
                sortable: false,
            }, {
                property: 'customer.email',
                label: this.$tc('tdcp-customer-prices.list.column.customerEmail'),
                allowResize: true,
                sortable: false,
            }, {
                property: 'customer.company',
                label: this.$tc('tdcp-customer-prices.list.column.customerCompany'),
                allowResize: true,
                sortable: false,
            }, {
                property: 'price',
                label: this.$tc('tdcp-customer-prices.list.column.basePrice'),
                allowResize: true,
                sortable: false,
            }, {
                property: 'createdAt',
                label: this.$tc('tdcp-customer-prices.list.column.createdAt'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'updatedAt',
                label: this.$tc('tdcp-customer-prices.list.column.updatedAt'),
                allowResize: true,
                sortable: true,
            }];
        },
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            // nothing needed
        },

        getList() {
            this.isLoading = true;
            const criteria = new Shopware.Data.Criteria(this.page, this.limit);
            criteria.setTerm(this.term);
            criteria.addSorting(Shopware.Data.Criteria.sort(this.sortBy, this.sortDirection));
            criteria.addAssociation('product');
            criteria.addAssociation('customer');

            if (this.productNumberFilter) {
                criteria.addFilter(Shopware.Data.Criteria.contains('product.productNumber', this.productNumberFilter));
            }
            if (this.customerNumberFilter) {
                criteria.addFilter(Shopware.Data.Criteria.contains('customer.customerNumber', this.customerNumberFilter));
            }

            return this.repository.search(criteria, Shopware.Context.api).then((result) => {
                this.items = result;
                this.total = result.total;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onProductNumberFilterChange(value) {
            this.productNumberFilter = value;
            this.page = 1;
            this.getList();
        },

        onCustomerNumberFilterChange(value) {
            this.customerNumberFilter = value;
            this.page = 1;
            this.getList();
        },

        formatPrice(price) {
            if (!price || !price.length) {
                return '-';
            }
            const currencyPrice = price[0];
            const gross = currencyPrice.gross;
            const net = currencyPrice.net;
            const currencySymbol = currencyPrice.currency?.symbol || 'EUR';

            return `${currencySymbol} ${gross.toFixed(2)} gross / ${net.toFixed(2)} net`;
        },
    },
});
